export default __webpack_public_path__ + "static/media/pricelist.3fc03a19.webp";